import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import React, { useState, useRef, useLayoutEffect, useEffect } from "react"
import shadowDOM from "components/Stacker/utils/shadowDOM"
import { usePrevious } from "reactHooks"

function StackerInfiniteScroll(props) {
  const [shouldRefresh, setShouldRefresh] = useState(true)
  const prev_heightRange = usePrevious(props.heightRange)
  const offsetHeight = useRef(0)
  const offsetWidth = useRef(0)

  useLayoutEffect(() => {
    const { heightRange, offset } = props
    if (!isMobile()) {
      if (heightRange > (prev_heightRange ?? 0) + offset && !shouldRefresh) {
        setShouldRefresh(true)
      }
    } else if (heightRange > setShouldRefresh && !shouldRefresh) {
      setShouldRefresh(true)
    }
  }, [prev_heightRange, props, props.heightRange, props.offset, shouldRefresh])

  useLayoutEffect(() => {
    const onScrollHorizontal = () => {
      const { handleRefresh } = props
      const el = shadowDOM.getElementsByClassName("product_list-body-list")[0]
      const el2 = shadowDOM.getElementsByClassName("product_list-body")[0]
      const documentOffset = el.offsetHeight
      const { innerHeight } = window
      const pageYOffset = el2.scrollTop
      const bufferHeight = documentOffset - (innerHeight + pageYOffset)
      const heightRange = 2000
      if (
        bufferHeight !== 0 &&
        bufferHeight < props.heightRange &&
        shouldRefresh
      ) {
        setShouldRefresh(false)
        handleRefresh({
          isInfiniteScroll: true,
        })
      } else if (bufferHeight > heightRange && !shouldRefresh) {
        setShouldRefresh(true)
      }
    }

    const onScrollVertical = () => {
      const el = shadowDOM.getElementsByClassName("product_list-body-list")[0]
      const {
        heightRange,
        handleRefresh,
        shouldCallHandleRefresh = true,
      } = props
      const documentOffset = document.body.offsetHeight
      const bufferHeight = documentOffset - (el.offsetHeight + el.offsetTop)
      const scrollback = el.getBoundingClientRect().y - offsetHeight.current

      if (
        shouldCallHandleRefresh &&
        bufferHeight !== 0 &&
        -scrollback > heightRange &&
        shouldRefresh
      ) {
        setShouldRefresh(false)
        handleRefresh({
          isInfiniteScroll: true,
        })
      }
    }
    const el = shadowDOM.getElementsByClassName("product_list-body")[0]
    const el2 = shadowDOM.getElementsByClassName("product_list-body-list")[0]

    if (!isMobile()) {
      el.addEventListener("scroll", onScrollVertical)
      offsetHeight.current = el2.getBoundingClientRect().y
    } else {
      el.addEventListener("scroll", onScrollHorizontal)
      offsetWidth.current = el2.getBoundingClientRect().x
    }
    return () => {
      // const el = shadowDOM.getElementsByClassName("product_list-body")[0]
      // el.removeEventListener("scroll", handleScroll, false)
      if (!isMobile()) {
        el.removeEventListener("scroll", onScrollVertical, false)
      } else {
        el.removeEventListener("scroll", onScrollHorizontal, false)
      }
    }
  }, [props, shouldRefresh])

  return <React.Fragment>{props.children}</React.Fragment>
}

StackerInfiniteScroll.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  handleRefresh: PropTypes.func.isRequired,
  heightRange: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  shouldCallHandleRefresh: PropTypes.bool,
}
export default StackerInfiniteScroll
